module.exports = __webpack_public_path__ + "img/menu-mobile.153fdaaa.svg";